<template>
    <div class="count " :class="isDisabled?'disabled':''">
        <div class="decrement" @click="decrement(kg)">
            <span class="el-icon-remove"></span>
        </div>
        <div class="show">
            <span class="numTips" v-show="count==0">數量</span>
            <span class="num" v-show="count>0">{{count}}</span>
        </div>
        <div class="increment" @click="increment(kg)">
            <span class="el-icon-circle-plus"></span>
        </div>
    </div>
</template>

<script>
// 引人组件
import StartingEndPoint from "@/components/StartingEndPoint"
import {mapActions} from 'vuex'
export default {
    mame:'',
    props:["isDisabled","kg","callback","count"],
    components:{
        StartingEndPoint
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions(["decrementLetterNum","incrementLetterNum"]),
        // 用户点击减
        decrement(kg){
            if(typeof this.callback == "function"){
                return this.callback(0)
            }
        },
        // 用户点击加
        increment(kg){
            if(typeof this.callback == "function"){
                return this.callback(1)
            }
        }
    },
}
</script>

<style lang="less" scoped>
        .count{
            display: flex;
            align-items: center;
            margin-right: 70px;
            .show{
                width: 150px;
                height: 56px;
                text-align: center;
                line-height: 56px;
                border: 2px solid #d7d7d7d7;
                border-radius: 10px;
                margin:0 5px;
                .numTips{
                    color: #B5B5B5;
                    font-size:17px;
                }
                .num{
                    font-size: 18px;
                }
            }
                .increment{
                    color:@colorMain;
                    font-size:30px;
                    &:hover{
                        cursor: pointer;
                    }
                }
                .decrement{
                    font-size:30px;
                    color: #868686;
                    &:hover{
                        cursor: pointer;
                    }
                }
        }
        .count.disabled{
            .show{
                background-color: #f5f7fa;
                &:hover{
                    cursor: not-allowed;
                }
            }
        }
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>